module.exports = __webpack_public_path__ + "f0195bc5c062bbad567a990bf3550fcd.MP3";